import type {EquipmentRunningTimes, RunningTimesEquipmentData} from '@hconnect/common/types'
import {Box, Typography} from '@mui/material'
import {EquipmentLabel} from '@widgets/common-shift-event'
import React from 'react'

import {EquipmentRunningTimesResultLegend} from './EquipmentRunningTimesResultLegend'

type RunningTimesViewProps = {
  equipment: RunningTimesEquipmentData
  runningTimePerformance?: EquipmentRunningTimes
  getStackedBarChartComponent?: React.ReactNode
  afterTitleComponent?: React.ReactNode
}

export const RunningTimesView: React.FC<RunningTimesViewProps> = ({
  equipment,
  runningTimePerformance,
  getStackedBarChartComponent,
  afterTitleComponent
}) => (
  <>
    <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="subtitle1" display="flex" gap={2}>
        <EquipmentLabel withId={false} withText equipment={equipment} />
        {afterTitleComponent}
      </Typography>
      <EquipmentRunningTimesResultLegend
        totalRunning={runningTimePerformance?.totalRunning}
        totalStopped={runningTimePerformance?.totalStopped}
      />
    </Box>
    <Box display={'flex'} alignItems={'stretch'} flexWrap={'wrap'} width="100%">
      <Box
        sx={{
          flex: '1',
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'flex-start',
          borderRadius: 1,
          overflow: 'hidden'
        }}
      >
        {getStackedBarChartComponent}
      </Box>
    </Box>
  </>
)
